import actionTypes from 'src/modules/redux/actionTypes'

export const setJobFieldSpecification = spec => ({
  type: actionTypes.SET_JOB_FIELD_SPECIFICATION,
  payload: spec
})
